import React, { useContext } from 'react';

import {
  AppConstantsContext,
  JobType,
  Pricing,
  PricingTable,
  Product,
  SUB_ID_TYPES,
  useABTest,
} from '@klangio/react-shared-elements';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  app: {
    textAlign: 'center',
    color: '#fff',
  },
}));

interface PricingContainerWidgetProps {
  subscriptionIds?: SUB_ID_TYPES;
  baseUrl?: string;
}

const PricingContainerWidget: React.FC<PricingContainerWidgetProps> = ({
  subscriptionIds,
  baseUrl,
}) => {
  const { classes } = useStyles();
  const { jobType } = useContext(AppConstantsContext);
  const { useVariant } = useABTest();

  function onClickPurchase(product: Product, isYearly: boolean, specialEventCode: string) {
    if (!product.planId) {
      if ((window as any).jQuery) {
        (window as any).jQuery([document.documentElement, document.body]).animate(
          {
            scrollTop: (window as any).jQuery('#demo').offset().top,
          },
          500,
        );
      } else {
        window.location.href = '#demo';
      }
    } else {
      const productId = isYearly ? product.planIdYearly : product.planId;
      if (specialEventCode) {
        window.location.href = `https://auth.klang.io/buy?product_id=${productId}&code=${specialEventCode}&redirect_url=${baseUrl}`;
      } else {
        window.location.href = `https://auth.klang.io/buy?product_id=${productId}&redirect_url=${baseUrl}`;
      }
    }
  }
  if (jobType === JobType.TranscribeScan || useVariant) {
    return (
      <div className={classes.app}>
        <Pricing wordpress />
      </div>
    );
  }
  return (
    <div className={classes.app}>
      <PricingTable
        // discount={0.3}
        withSingleTicket={false}
        subscriptionIds={subscriptionIds}
        // eslint-disable-next-line max-len
        onClickPurchase={(product, isYearly, specialEventCode) => onClickPurchase(product, isYearly, specialEventCode)}
      />
    </div>
  );
};

export default PricingContainerWidget;
